import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Notifications from 'components/Notifications';

import { clearNotification } from '../actions';
import { makeSelectNotification } from '../selectors';

export default function AppNotifications() {
  const notification = useSelector(makeSelectNotification());
  const dispatch = useDispatch();
  const dispatchClearNotification = () => {
    dispatch(clearNotification());
  };

  return <Notifications notification={notification} onShow={dispatchClearNotification} />;
}
